import {
  Box,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
} from '@chakra-ui/react'
import type { PropsWithChildren, ReactElement } from 'react'
import { useMemo } from 'react'
import { isNull, isUndefined } from 'lodash'
import BulkEditModeDropdown from './BulkEditModeDropdown'
import type { CMFieldProps } from '.'

const CMNumberField = ({
  cmField,
  disabled,
  readOnly,
  placeholder,
  isUpload,
  form,
  children,
  labelElement,
  showBulkEditFieldModeDropdown,
  bulkEditFieldMode,
  style,
  required,
  menuPosition,
  setBulkEditFieldMode,
  onInputChange,
}: PropsWithChildren<CMFieldProps>): ReactElement => {
  const shouldShowFormField = useMemo(() => {
    if (!showBulkEditFieldModeDropdown) {
      return true
    }

    return bulkEditFieldMode?.[cmField.name] === 'set'
  }, [bulkEditFieldMode, cmField.name, showBulkEditFieldModeDropdown])
  return (
    <FormControl
      marginBottom={isUpload ? 0 : '30px'}
      isInvalid={Boolean(form.errors?.upload?.[cmField.name])}
      isRequired={cmField.schema.isValueRequired}
      isDisabled={disabled}
      style={style}
    >
      {labelElement ?? <FormLabel>{cmField.label}</FormLabel>}
      <Box width="100%">
        {showBulkEditFieldModeDropdown &&
          bulkEditFieldMode &&
          setBulkEditFieldMode && (
            <BulkEditModeDropdown
              bulkEditFieldMode={bulkEditFieldMode}
              setBulkEditFieldMode={setBulkEditFieldMode}
              cmField={cmField}
              disabled={readOnly || disabled}
              menuPosition={menuPosition}
              onInputChange={() => {
                onInputChange?.(cmField, form)
              }}
            />
          )}
        {shouldShowFormField && (
          <>
            <Input
              type="number"
              disabled={disabled}
              readOnly={readOnly || disabled}
              name={`upload.['${cmField.name}']`}
              value={
                isUndefined(form.values?.upload?.[cmField.name]) ||
                isNull(form.values?.upload?.[cmField.name])
                  ? ''
                  : Number(form.values?.upload?.[cmField.name])
              }
              onChange={e => {
                const value = e.target.value
                if (value.length === 0) {
                  form.setFieldValue(`upload.['${cmField.name}']`, null)
                  onInputChange?.(cmField, form, undefined)
                } else {
                  const num = parseFloat(value)
                  if (isFinite(num)) {
                    form.setFieldValue(`upload.['${cmField.name}']`, num)
                    onInputChange?.(cmField, form, num)
                  } else {
                    form.setFieldValue(`upload.['${cmField.name}']`, value)
                    onInputChange?.(cmField, form, value)
                  }
                }
              }}
              required={required}
              placeholder={placeholder}
            />
            <FormErrorMessage>
              {form.errors?.upload && form.errors?.upload[cmField.name]}
            </FormErrorMessage>
          </>
        )}
      </Box>
      {children}
    </FormControl>
  )
}


export default CMNumberField
